module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 13
// module chunks = 0